import { fetchFormStyleSettings as fetchFormStyleSettingsFromApi } from './api';
import { getSettings as getSettingsIfPresent, getSettingsLastFetched } from './selectors';
function createAction(name) {
  return `@@settings/${name}`;
}
export const REQUEST_SETTINGS = createAction('REQUEST_SETTINGS');
export const RECEIVE_SETTINGS = createAction('RECEIVE_SETTINGS');
export const SUCCEED_GETTING_SETTINGS = createAction('SUCCEED_GETTING_SETTINGS');
export const FAIL_GETTING_SETTINGS = createAction('FAIL_GETTING_SETTINGS');
const MAX_DATA_AGE = 300000; // 5 minutes in millis

const requestSettings = () => ({
  type: REQUEST_SETTINGS
});
const receiveSettings = settings => ({
  type: RECEIVE_SETTINGS,
  settings,
  meta: {
    timestamp: Date.now()
  }
});
const succeedGettingSettings = () => ({
  type: SUCCEED_GETTING_SETTINGS
});
const failGettingSettings = () => ({
  type: FAIL_GETTING_SETTINGS
});
const fetchFormStyleSettings = () => dispatch => {
  dispatch(requestSettings());
  return fetchFormStyleSettingsFromApi().then(response => {
    dispatch(receiveSettings({
      ['Forms:Style']: response.value
    }));
    dispatch(succeedGettingSettings());
  }, err => {
    switch (err.status) {
      case 404:
        dispatch(receiveSettings({
          ['Forms:Style']: {
            value: ''
          }
        }));
        dispatch(succeedGettingSettings());
        break;
      default:
        dispatch(failGettingSettings());
        break;
    }
  });
};
export const fetchSettingsIfNeeded = () => (dispatch, getState) => {
  dispatch(requestSettings());
  const settings = getSettingsIfPresent(getState());
  const lastFetched = getSettingsLastFetched(getState());
  const isEmpty = Object.keys(settings).length === 0;
  const isExpired = Date.now() - (lastFetched || 0) > MAX_DATA_AGE;
  if (isEmpty || !lastFetched || isExpired) {
    return dispatch(fetchFormStyleSettings());
  }
  dispatch(succeedGettingSettings());
  dispatch(receiveSettings(settings));
  return Promise.resolve();
};